import React from "react";
import PropTypes from "prop-types";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function StyledBadge(props) {
  let { text = "text", styles = [""], className, children, ...other } = props;

  if (!Array.isArray(styles)) {
    styles = [""];
  }
  if (typeof text !== "string") {
    styles = [""];
  }

  const convertedText = text
    .split("")
    .reduce((acc, prev) => acc + prev.charCodeAt(0), 0);

  const style = styles[convertedText % styles.length];
  return (
    <div className={classNames(className, style)} {...other}>
      {children}
    </div>
  );
}

StyledBadge.propTypes = {
  props: PropTypes.object,
};

export default StyledBadge;
